import React from "react";

import { ITextBoxField } from "../models/formFields.interfaces";
import { AbstractFormField, IFormFieldState } from "./AbstractFormField";

// TODO(ssr, LEVEL 4 out of 10): Migrate to functional component
// Complexity: Multi-line textarea input. Extends AbstractFormField directly for HTMLTextAreaElement
// (not HTMLInputElement like most other inputs). Implements updateValueAttribute() and buildControl()
// abstract methods. Has getInputProps() with rows/cols/minLength/maxLength/aria-expanded config. No
// complex formatting, validation, or lifecycle methods beyond parent class.
// Migration: Use useFormField hook (from migrated AbstractFormField) specialized for HTMLTextAreaElement.
// Replace inputElem ref with useRef. The updateValueAttribute logic becomes part of onChange handler.
// Straightforward migration - main complexity is ensuring the generic types work correctly with
// HTMLTextAreaElement instead of HTMLInputElement. Simpler than most other input components.
export class FormTextbox<T extends string> extends AbstractFormField<
    T,
    HTMLTextAreaElement,
    ITextBoxField<T>,
    IFormFieldState
> {
    public static defaultProps = {
        type: "textbox",
    };

    public state: IFormFieldState = {
        focused: false,
    };

    protected updateValueAttribute(
        event: React.FormEvent<HTMLTextAreaElement>,
    ): void {
        this.value = event.currentTarget.value;
    }

    protected getInputProps() {
        return Object.assign(super.getInputProps(), {
            "rows": this.props.rows,
            "cols": this.props.cols,
            "minLength": this.props.minLength,
            "maxLength": this.props.maxLength,
            "aria-expanded": this.props.ariaExpanded,
        });
    }

    protected buildControl(): React.JSX.Element {
        const props = this.getInputProps();
        return (
            <textarea
                ref={(ref) => {
                    this.inputElem = ref;
                }}
                {...props}
            ></textarea>
        );
    }
}
